import { useState, useEffect } from 'react';

const useDraftSaving = (templateId) => {
  const [hasDraft, setHasDraft] = useState(false);
  const draftKey = `draft_${templateId}`;

  useEffect(() => {
    // Check if draft exists
    const savedDraft = localStorage.getItem(draftKey);
    setHasDraft(!!savedDraft);
  }, [draftKey]);

  const saveDraft = (formData, logos) => {
    try {
      const draft = {
        formData,
        logos,
        timestamp: new Date().toISOString()
      };
      localStorage.setItem(draftKey, JSON.stringify(draft));
      setHasDraft(true);
      return true;
    } catch (error) {
      console.error('Error saving draft:', error);
      return false;
    }
  };

  const loadDraft = () => {
    try {
      const savedDraft = localStorage.getItem(draftKey);
      if (savedDraft) {
        return JSON.parse(savedDraft);
      }
      return null;
    } catch (error) {
      console.error('Error loading draft:', error);
      return null;
    }
  };

  const deleteDraft = () => {
    localStorage.removeItem(draftKey);
    setHasDraft(false);
  };

  const getAllDrafts = () => {
    const drafts = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('draft_')) {
        try {
          const draft = JSON.parse(localStorage.getItem(key));
          drafts.push({
            templateId: key.replace('draft_', ''),
            ...draft
          });
        } catch (error) {
          console.error('Error reading draft:', error);
        }
      }
    }
    return drafts;
  };

  return {
    hasDraft,
    saveDraft,
    loadDraft,
    deleteDraft,
    getAllDrafts
  };
};

export default useDraftSaving;
